import axiosInstance from "./axiosInstance";

export const getEmergencyContacts = async (locale = "en") => {
  const res = await axiosInstance.get(
    `/api/emergency-contacts?locale=${locale}&sort=order`
  );

  return res.data.data.map((item) => ({
    id: item.id,
    title: item.title,
    number: item.number,
    color: item.color,
  }));
};
